export const HttpStatusEnum = {
  SUCCESS: "200",
  NOT_FOUND: "404",
  FULFILLED: "fulfilled",
  REJECTED: "rejected",
};
